import React, { useEffect, useState } from "react";
import { Offcanvas } from "react-bootstrap";
import service from "../../../assets/svg/serviceIcon.svg";

import edit from "../../../assets/Asssignment/edit.png";
import trash from "../../../assets/Asssignment/delete.png";
import closeoff from "../../../assets/Asssignment/close.png";
import tata from "../../../assets/Vehicles/tata.png";
import vendor from "../../../assets/svg/vendor.svg";
import calender from "../../../assets/svg/calender.svg";

import { getReminderDetailsApi } from "../services-api.js";
import { useGlobal } from "../../../GlobalContext.js";


export const ViewReminder = ({ id, show, handleClose, selectedRowData, editReminder }) => {
  const { rolePermissionList, userType } = useGlobal();

  useEffect(() => {
    if (id != null && id !== undefined) {
      getReminderDetails(id);
    }
  }, [id]);

  const [reminderDetail, setReminderDetail] = useState({});

  const getReminderDetails = async (id) => {
    try {
      const response = await getReminderDetailsApi(id);

      if (response.data.success === true) {
        setReminderDetail(response.data.reminder ?? {});
      } else {
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };
  const details = [
    {
      label: "Due date",
      value: (
        <div className="d-flex align-items-center gap-2">
          <img src={calender} alt="vendor" />
          <span>{reminderDetail.due_date ?? "---"}</span>
        </div>
      ),
    },

    // {
    //   label: "Vendor",
    //   value: (
    //     <div className="d-flex align-items-center gap-2">
    //       <img src={vendor} alt="vendor" />
    //       <span>{reminderDetail.vendor??'---'}</span>
    //     </div>
    //   ),
    // },
    {
      label: "Description",
      value: reminderDetail.description ?? "---",
    },
  ];

   function checkPermission(menuName, permission) {
    return rolePermissionList.findIndex(
      (element) =>
        element["name"] === menuName &&
        element["menu_permission"] === true &&
        element[permission] === true
    ) > -1
      ? true
      : false;
  }

  return (
    <Offcanvas show={show} onHide={handleClose} placement="end" style={{ width: "520px" }}>
      <Offcanvas.Header closeButton={false} className="d-flex justify-content-between align-items-center p-0">
        <Offcanvas.Title className="bg-grey w-100 p-3 d-flex flex-wrap justify-content-center align-items-center justify-content-xl-between">
          <div>
            <div className="d-flex gap-3">
              <img src={service} alt="oil" className="p-3 bg-white rounded-4" />
              <div className="d-flex flex-column">
                <p className="m-0 fs-20 fw-800 mb-1 ">{reminderDetail.name ?? ""}</p>
                <div className="d-flex align-items-center">
                  <span className="me-2 fs-13 fw-600" style={{color:'#A2A7AE'}}>ID : {reminderDetail.service ?? ""}</span>
                  <span className="me-2" style={{ color: "#D9D9D9" }}>
                    •
                  </span>
                  <span className="border-0  py-1 px-4 rounded-pill fs-12 fw-600 d-inline-flex align-items-center gap-2" >
                    <span
                      style={{
                        backgroundColor: "#2C8C53",
                        height: "8px",
                        width: "8px",
                      }}
                    ></span>
                    {reminderDetail.status ?? ""}
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="d-flex gap-3">
            {checkPermission("Service Reminders", "edit_permission") && (<img
              src={edit}
              onClick={() => {
                editReminder(id);
              }}
              alt="edit"
              className="cursor-pointer"
            />)}
            {/*  <img src={trash} alt="trash" className="cursor-pointer" /> */}
            <img src={closeoff} alt="closeoff" className="cursor-pointer" onClick={handleClose} />
          </div>
        </Offcanvas.Title>
      </Offcanvas.Header>

      <Offcanvas.Body>
        <div className="p-3 rounded-4 my-3" style={{ backgroundColor: "#F8F8F8" }}>
          <div className="d-flex gap-3">
            <div className="rounded-4" style={{ backgroundColor: "#E8E8E8" }}>
              <img src={tata} alt="tata" />
            </div>
            <div>
              <p className="m-0 fs-16 fw-semibold mb-1"  style={{color:'#21272C'}}>{reminderDetail.lic_no ?? ""}</p>
              <div className="d-flex align-items-center">
                <span className="me-2 fs-14 fw-400" style={{color:'#A2A7AE'}}>{reminderDetail.name ?? ""}</span>
                <span className="me-2">•</span>
                {reminderDetail.year_of_make &&(<span style={{background:'#F0DBFF', color:'#A2A7AE'}} className="border-0 py-1 px-4 rounded-pill  fs-12">{reminderDetail.year_of_make ?? ""}</span>)}
              </div>
            </div>
          </div>
          <div className="bg-white rounded-4 mt-3 p-2 d-flex justify-content-center align-items-center">
            <span className="fs-13 fw-400" style={{ color: "#8790A1" }}>Vehicle identification number (VIN) : </span>
            <span className="fs-14 fw-500" style={{ color: "#172B4D" }}>&nbsp;{reminderDetail.vin ?? ""}</span>
          </div>
        </div>

        <div>
          <p className="m-0 fs-15 fw-600" style={{ color: "#212129" }}>Other details</p>
          <div className="table-container rounded-4 overflow-hidden my-3">
            <table className="table table-borderless mb-0">
              <tbody>
                {details.map((item, index) => (
                  <tr key={index}>
                    <td className="fs-13 fw-500" style={{ color: "#49494B" }}>
                      {item.label}
                    </td>
                    <td className="fs-13 fw-400" style={{ color: "#172B4D" }}>
                      {item.value}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

         
        </div>
      </Offcanvas.Body>
    </Offcanvas>
  );
};
